import styled from '@emotion/styled';

export const Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
